import React, { useState, useEffect, useRef, forwardRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getVendorAuditDetails ,updateVendorAuditDetails, uploadVendorAuditAttachment, clearVendorAuditAttachments, clearVendorAuditDrafts, clearVendorAuditRowDrafts} from "../../../../services/audit_redux/audit_actions/VendorAudit.action";
import { GoChevronRight } from "react-icons/go";
import auditbreadcrumb_icon from "../../../../assets/audit_assets/Create_Audit/auditbreadcrumb_icon.png";
import mainIcon from "../../../../assets/audit_assets/audit_details/main_icon.png";
import headerIcon from "../../../../assets/audit_assets/audit_details/headerIcon.png";
import { FaEye } from "react-icons/fa";
import { FaUpload } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';  
import Button from '@mui/material/Button';
import AttachmentViewer from '../../../reUsableTemplates/fileviewer/AttachmentViewer';
import { FaPlusCircle,FaTimesCircle } from "react-icons/fa";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const parseAttachmentList = (raw) => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.filter(Boolean).map(String);
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (!trimmed || trimmed === "[]") return [];
    try {
      const parsed = JSON.parse(trimmed.replace(/\\/g, "/"));
      if (Array.isArray(parsed)) return parsed.filter(Boolean).map(String);
      if (parsed) return [String(parsed)];
    } catch {
      return trimmed.split(",").map((part) => part.trim()).filter(Boolean);
    }
  }
  return [];
};

const ROW_MAX_BYTES = 30 * 1024 * 1024;

const storedAttachmentName = (path, rowId) => {
  const name = String(path || "").replace(/\\/g, "/").split("/").pop();
  const prefix = `${rowId}_`;
  return name.startsWith(prefix) ? name.slice(prefix.length) : name;
};

const isSameUploadedFile = (path, fileName, rowId) => {
  const stored = storedAttachmentName(path, rowId).toLowerCase();
  const picked = String(fileName || "").replace(/\\/g, "/").split("/").pop().toLowerCase();
  const pickedSafe = picked.replace(/\s+/g, "_");
  return Boolean(stored && picked && (stored === picked || stored === pickedSafe));
};

function VendorAuditUpdate({setLoading,showSnackbar}) {
const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState([]);
  const [changedRows, setChangedRows] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [allData, setAllData] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const [currentStatus , setCurrentStatus] = useState('Audit')
  // const [auditData, setAuditData] = useState(groupedData); 
  const [months, setMonths] = useState([]);
  const [currentMonthIndex, setCurrentMonthIndex] = useState(0);
  const [openCompleteAlert,setOpenCompleteAlert] = useState(false);
  const [openCompleteAlertOne,setOpenCompleteAlertOne] = useState(false);
  const [actionCheck,setActionCheck] = useState(false);
  const [previewableRows, setPreviewableRows] = useState({});
  const [draftsByRow, setDraftsByRow] = useState({});
  const [openOverrideAlert, setOpenOverrideAlert] = useState(false);
  const [overrideFileName, setOverrideFileName] = useState("");
  const overrideResolverRef = useRef(null);
  const header = [
    { key: "actName", value: "Act Name", icon: headerIcon },
    // { key: "section_id", value: "Section", icon: headerIcon },
    { key: "ruleName", value: "Rule", icon: headerIcon },
    { key: "ruleNumber", value: "Rule Number", icon: headerIcon },
    { key: "period_month", value: "Period Month", icon: headerIcon },
    { key: "activityName", value: "Particulars", icon: headerIcon },
    { key: "Attachment", value: "Attachment", icon: headerIcon },
    { key: "remark", value: "Remark", icon: headerIcon }]    
    if (!actionCheck) {
      header.push(
          { key: "auditors_remark", value: "Auditor Remark", icon: headerIcon },
          { key: "status", value: "Status", icon: headerIcon }
      );
  }
  const fetchData = async ({ preserveMonth = false } = {}) => {
    try {
      await dispatch(clearVendorAuditDrafts(id));
      setDraftsByRow({});
      const response = await dispatch(getVendorAuditDetails(id));
      const status = response?.data?.status;
      if(response.success){
        setCurrentStatus(status);
        if(status === "Vendor-In-Progress" || status === "Audit"){
          setActionCheck(true)
        }else{
          setActionCheck(false)
        }
      }
      const data = response?.data?.templates?.flatMap(t => t.activities) || [];
      const grouped = data.reduce((acc, item) => {
        if (!acc[item.period_month]) acc[item.period_month] = [];
        acc[item.period_month].push(item);
        return acc;
      }, {});
      const monthOrder = Object.keys(grouped).sort();
      setAllData(data);
      setGroupedData(grouped);
      setMonths(monthOrder);
      if (!preserveMonth) {
        setCurrentMonthIndex(0);
      }
      setFormValues(data.map(a => ({ id: a.id, remark: a.remark, attachment: null })));
      const allowPreview = status === "Vendor-In-Progress" || (status && status !== "Audit");
      const nextPreview = {};
      if (allowPreview) {
        data.forEach((row) => {
          if (parseAttachmentList(row.attachment).length) {
            nextPreview[row.id] = true;
          }
        });
      }
      setPreviewableRows(nextPreview);
    } catch (err) {
      console.error("Failed to fetch audit data:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  const handleRemarkChange = (id, value) => {
    setFormValues(prev =>
      prev.map(f => (f.id === id ? { ...f, remark: value } : f))
    );

    setChangedRows(prev => ({
      ...prev,
      [id]: { ...(prev[id] || {}), remark: value }
    }));
  };

  const applySavedAttachments = (id, attachments, totalBytes) => {
    const stored = JSON.stringify(attachments || []);
    setAllData((prev) =>
      prev.map((row) =>
        row.id === id
          ? { ...row, attachment: stored, attachment_bytes: totalBytes ?? row.attachment_bytes ?? 0 }
          : row
      )
    );
    setGroupedData((prev) => {
      const next = { ...prev };
      Object.keys(next).forEach((month) => {
        next[month] = next[month].map((row) =>
          row.id === id
            ? { ...row, attachment: stored, attachment_bytes: totalBytes ?? row.attachment_bytes ?? 0 }
            : row
        );
      });
      return next;
    });
  };

  const applyDrafts = (id, drafts, totalBytes) => {
    setDraftsByRow((prev) => ({ ...prev, [id]: drafts || [] }));
    setAllData((prev) =>
      prev.map((row) =>
        row.id === id
          ? { ...row, attachment_bytes: totalBytes ?? row.attachment_bytes ?? 0 }
          : row
      )
    );
    setGroupedData((prev) => {
      const next = { ...prev };
      Object.keys(next).forEach((month) => {
        next[month] = next[month].map((row) =>
          row.id === id
            ? { ...row, attachment_bytes: totalBytes ?? row.attachment_bytes ?? 0 }
            : row
        );
      });
      return next;
    });
  };

  const askOverride = (fileName) =>
    new Promise((resolve) => {
      setOverrideFileName(fileName);
      setOpenOverrideAlert(true);
      overrideResolverRef.current = resolve;
    });

  const handleOverrideChoice = (shouldOverride) => {
    setOpenOverrideAlert(false);
    setOverrideFileName("");
    if (!overrideResolverRef.current) return;
    overrideResolverRef.current(shouldOverride);
    overrideResolverRef.current = null;
  };

  const uploadOneFile = async (id, file, usedBytes, currentPaths, override = false) => {
    if (!override && usedBytes + file.size > ROW_MAX_BYTES) {
      showSnackbar(
        `${file.name} cannot be uploaded. Total attachments for this row cannot exceed 30 MB.`,
        "warning"
      );
      return { usedBytes, currentPaths, uploaded: false };
    }

    const response = await dispatch(uploadVendorAuditAttachment(id, file, override));
    if (response.success) {
      applyDrafts(id, response.drafts, response.total_bytes);
      const draftPaths = (response.drafts || []).map((item) => item.name || item.path);
      return {
        usedBytes: Number(response.total_bytes) || usedBytes,
        currentPaths: [...(response.attachments || []), ...draftPaths],
        uploaded: true,
      };
    }
    showSnackbar(response.message || `Failed to upload ${file.name}`, "warning");
    return { usedBytes, currentPaths, uploaded: false };
  };

  const handleFileChange = async (id, files, event, { replaceDrafts = false } = {}) => {
    if (event?.target) event.target.value = "";
    const picked = Array.from(files || []);
    if (!picked.length) return;

    const row = allData.find((item) => item.id === id);
    let usedBytes = Number(row?.attachment_bytes) || 0;
    let draftPaths = (draftsByRow[id] || []).map((item) => item.name || item.path);

    if (replaceDrafts && (draftsByRow[id] || []).length > 0) {
      const cleared = await dispatch(clearVendorAuditRowDrafts(id));
      if (!cleared.success) {
        showSnackbar(cleared.message || "Failed to replace attachment", "warning");
        return;
      }
      applyDrafts(id, [], cleared.total_bytes || 0);
      usedBytes = Number(cleared.total_bytes) || 0;
      draftPaths = [];
    }

    let currentPaths = [...parseAttachmentList(row?.attachment), ...draftPaths];

    for (const file of picked) {
      const alreadyUploaded = currentPaths.some((path) =>
        isSameUploadedFile(path, file.name, id)
      );

      if (alreadyUploaded) {
        const shouldOverride = await askOverride(file.name);
        if (!shouldOverride) continue;
        const result = await uploadOneFile(id, file, usedBytes, currentPaths, true);
        usedBytes = result.usedBytes;
        currentPaths = result.currentPaths;
        continue;
      }

      const result = await uploadOneFile(id, file, usedBytes, currentPaths, false);
      usedBytes = result.usedBytes;
      currentPaths = result.currentPaths;
    }
  };

  const handleCancelUpload = async (rowId) => {
    const draftCount = (draftsByRow[rowId] || []).length;
    setLoading(true);
    try {
      if (draftCount > 0) {
        const response = await dispatch(clearVendorAuditRowDrafts(rowId));
        if (!response.success) {
          showSnackbar(response.message || "Failed to remove attachment", "warning");
          return;
        }
        applyDrafts(rowId, [], response.total_bytes || 0);
        return;
      }

      const response = await dispatch(clearVendorAuditAttachments(rowId));
      if (!response.success) {
        showSnackbar(response.message || "Failed to remove attachment", "warning");
        return;
      }
      applySavedAttachments(rowId, response.attachments || [], 0);
      setPreviewableRows((prev) => {
        const copy = { ...prev };
        delete copy[rowId];
        return copy;
      });
    } catch (err) {
      showSnackbar("Failed to remove attachment", "error");
    } finally {
      setLoading(false);
    }
  };
  
  

  const handleSubmit = async(e) => {
    e.preventDefault();
    const action = e.nativeEvent.submitter.name;
    if(action){
      if (action === "save") {
        handleUpdateAudit(action);
      }else{
        const filteredData = allData.filter(item => {
          const hasRemark = item.remark && item.remark.trim() !== "";
  
          const hasAttachment =
            item.attachment &&
            item.attachment !== "[]" &&
            (Array.isArray(item.attachment)
              ? item.attachment.length > 0
              : true);
  
          return hasRemark || hasAttachment;
        });
        const hasDrafts = Object.values(draftsByRow).some((files) => (files || []).length > 0);
        const objectCount = Object.keys(changedRows).length;
        if(filteredData.length === 0 && objectCount === 0 && !hasDrafts){
          setOpenCompleteAlertOne(true)
        }else{
          setOpenCompleteAlert(true)
        }
      }
    }
  };
  const handleUpdateAudit = async(action)=>{
    if(action){
      setLoading(true);
      const modifiedData = Object.entries(changedRows).map(([key, value]) => {
        const rowId = parseInt(key, 10);
        const formRow = formValues.find((row) => row.id === rowId);
        return {
          id: rowId,
          remark: value.remark ?? formRow?.remark ?? "",
          attachment: null,
        };
      });
  
      const formData = new FormData();
      modifiedData.forEach(item => {
        formData.append("data[]", JSON.stringify({ id: item.id, remark: item.remark }));
      });
      if (modifiedData.length === 0) {
        modifiedData.push(formValues[0]);
      }
      let status = ""
      if (action === "save") {
        status ="Vendor-In-Progress"
      } else{
        status ="Audit-Pending"
      }
      try {
        const datas = {
          data:modifiedData
        }
        const response = await dispatch(updateVendorAuditDetails(status,datas))
        if(response.success){
          navigate('/vendor/Audit', {
            state: { message: response.message || 'Audit details updated successfully!', type: 'success',statusData:status }
          });
          setLoading(false);

        }else{

          showSnackbar(response.message, 'warning');
          setLoading(false);
        }
      } catch (error) {
        showSnackbar('An error occurred', 'error');
        console.error(error);
        setLoading(false);
      }
    }

  }
  const currentMonth = months[currentMonthIndex];
  const auditDataRaw = groupedData[currentMonth] || [];
  
useEffect(() => { 
  setSearchQuery("");
}, [currentMonthIndex]);

  
  const auditData = Array.isArray(auditDataRaw)
    ? auditDataRaw.filter(item =>
        Object.values(item).some(value =>
          String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
      )
    : [];
  const setOpenCompleteAlertFalse = ()=>{
    setOpenCompleteAlert(false);
  }
  const setOpenCompleteAlertOneFalse = ()=>{
    setOpenCompleteAlertOne(false);
  }
  const handleUpdateAuditData = ()=>{
    handleUpdateAudit("complete");
    setOpenCompleteAlert(false);
  }
  const formatMonth = (value) => {
    if (!value) return "";
  
    const [year, month] = value.split("-");
    const shortMonth = new Date(`${year}-${month}-01`).toLocaleString("en-US", {
      month: "short",
    });
  
    return `${shortMonth.toUpperCase()}-${year}`;
  };

  const [showModal, setShowModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileId, setFileId] = useState(0);

  const handleEyeClick = (files, dataId) => {
    setFileId(dataId);
    setSelectedFiles(parseAttachmentList(files).map((path) => String(path).replace(/\\/g, "/")));
    setShowModal(true);
  };
  
  
  return (
    <div className='container-fluid'>
      <div className="row mt-4">
        <div className="col-md-12">
          {/* <div className="create-audit-header d-flex ">
          <img src={auditbreadcrumb_icon} alt="" /><h5 className='breadcrumbdata text-white'>Audit 
          <span><GoChevronRight /></span>  Audit Details
          </h5>
          </div> */}
          <div className="create-audit-header d-flex">
              <img src={auditbreadcrumb_icon} alt="" />
              
              <h5 className="breadcrumbdata text-white">
                <span
                  className="breadcrumb-link"
                  onClick={() => navigate("/vendor/Audit", {
                    state: {  statusData: currentStatus }
                  })}
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                >
                  Audit
                </span>

                <span><GoChevronRight /></span> 
                {actionCheck ? <>Audit Details</>:<>Completed Audit Details</>}
                
              </h5>
            </div>
          <div className="row">
            <div className='container-fluid vendorEditableTable-main-contaner '>
              <div className='row FormsTable-main mb-5'>
                <div className="table-header">
                  <div className="row d-flex">
                    <div className="col d-flex justify-content-between  pe-1">
                      <div className="title-data d-flex"><div className="table_main_img"
                      ><img src={mainIcon} alt="noImg" className='dataImg' /></div>
                        <p className="dataTitle">Audit Details</p> 
                        <div className="FormsTable-search-box position-relative">
                          <input
                            type="text"
                            className=""
                            placeholder="Search here..."
                            style={{
                              backgroundColor: "#f9fafb",
                              border: "none",
                              width: "250px"
                            }}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                          <i
                          className="bi bi-search position-absolute"
                          style={{
                            top: "39%",
                            left: "20px",
                            transform: "translateY(-50%)",
                            color: "#9ca3af"
                          }}
                          ></i>
                        </div>
                      </div>
                      <div className='float-end d-flex'> 
                        <div className="dataTotalEntries"><p>Total Entries :{auditData?.length}</p></div>
                        <div className="filter_or_createcomponentn"> 
                        <select
                          className="form-select"
                          value={currentMonthIndex}
                          onChange={(e) => setCurrentMonthIndex(Number(e.target.value))}
                        >
                          {months.map((m, index) => {
                            const [year, month] = m.split("-");
                            const shortMonth = new Date(`${year}-${month}-01`).toLocaleString("en-US", {
                              month: "short",
                            });

                            return (
                              <option key={m} value={index}>
                                {shortMonth.toUpperCase()}-{year}
                              </option>
                            );
                          })}
                        </select>

                        </div>
                        <div className={`filter_or_createcomponentn d-flex `}>
                        </div>  
                      </div>
                    </div>
                      <div className="">
                      <div className="createAuditdiv d-flex justify-content-end">
                      </div>
                      <form onSubmit={handleSubmit}>
                        <div className='table-body bg-white p-0 table-roundedData mb-3 '>                        
                          <div
                          className={`table-responsive reuseableEditable `}
                          
                          >
                            <table className='table p-0 m-0' id='dataTable'>
                              <thead className="table-light auditDetailstHeader">
                                <tr>
                                  {header?.map((head) => (
                                    <th key={head.key}>
                                        {head.icon && <img src={head.icon} alt="" width="16" className="me-2" />}
                                        {head.value}
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {auditData.length > 0 ? (
                                  auditData.map((row, i) => {
                                    const savedFiles = parseAttachmentList(row.attachment);
                                    const savedCount = savedFiles.length;
                                    const draftCount = (draftsByRow[row.id] || []).length;
                                    const displayCount = draftCount > 0 ? draftCount : savedCount;
                                    const canPreview = Boolean(previewableRows[row.id]) && savedCount > 0 && draftCount === 0;

                                    return (
                                      <tr key={row.id}>
                                        {header?.map((head) => (
                                          <React.Fragment key={head.key}>
                                            {head.key === "Attachment" ? (
                                              <td>
                                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                  {actionCheck ? (
                                                    <>
                                                      {displayCount > 0 ? (
                                                        <>
                                                          <label
                                                            htmlFor={`file-${row.id}`}
                                                            title="Upload File"
                                                            style={{
                                                              cursor: "pointer",
                                                              display: "inline-flex",
                                                              alignItems: "center",
                                                              gap: "6px",
                                                            }}
                                                          >
                                                            <FaUpload
                                                              style={{
                                                                color: "#28a745",
                                                                transition: "color 0.3s ease",
                                                              }}
                                                            />
                                                            <span style={{ fontSize: "12px", color: "#495057" }}>
                                                              ({displayCount})
                                                            </span>
                                                          </label>
                                                          {canPreview && (
                                                            <>
                                                              <label
                                                                htmlFor={`file-add-${row.id}`}
                                                                title="Add File"
                                                                style={{ cursor: "pointer" }}
                                                              >
                                                                <FaPlusCircle
                                                                  style={{
                                                                    color: "#6c757d",
                                                                    transition: "color 0.3s ease",
                                                                  }}
                                                                />
                                                              </label>
                                                              <i
                                                                title="View attachment"
                                                                style={{ color: "#007bff", cursor: "pointer" }}
                                                                onClick={() => handleEyeClick(savedFiles, row.id)}
                                                              >
                                                                <FaEye />
                                                              </i>
                                                              <i
                                                                title="Remove attachment"
                                                                style={{
                                                                  color: "#dc3545",
                                                                  cursor: "pointer",
                                                                  marginLeft: "4px",
                                                                  fontSize: "12px",
                                                                }}
                                                                onClick={() => handleCancelUpload(row.id)}
                                                              >
                                                                <FaTimesCircle />
                                                              </i>
                                                            </>
                                                          )}
                                                        </>
                                                      ) : (
                                                        <label
                                                          htmlFor={`file-${row.id}`}
                                                          title="Upload File"
                                                          style={{
                                                            cursor: "pointer",
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: "6px",
                                                          }}
                                                        >
                                                          <FaUpload
                                                            style={{
                                                              color: "#6c757d",
                                                              transition: "color 0.3s ease",
                                                            }}
                                                          />
                                                        </label>
                                                      )}

                                                      <input
                                                        id={`file-${row.id}`}
                                                        type="file"
                                                        accept=".xlsx,.xls,.pdf,image/*"
                                                        style={{ display: "none" }}
                                                        multiple
                                                        onChange={(e) =>
                                                          handleFileChange(
                                                            row.id,
                                                            Array.from(e.target.files),
                                                            e,
                                                            { replaceDrafts: true }
                                                          )
                                                        }
                                                      />
                                                      <input
                                                        id={`file-add-${row.id}`}
                                                        type="file"
                                                        accept=".xlsx,.xls,.pdf,image/*"
                                                        style={{ display: "none" }}
                                                        multiple
                                                        onChange={(e) =>
                                                          handleFileChange(
                                                            row.id,
                                                            Array.from(e.target.files),
                                                            e
                                                          )
                                                        }
                                                      />
                                                    </>
                                                  ) : (
                                                    savedCount > 0 && (
                                                      <>
                                                        <i
                                                          style={{ color: "#007bff", cursor: "pointer" }}
                                                          onClick={() => handleEyeClick(savedFiles, row.id)}
                                                        >
                                                          <FaEye />
                                                        </i>
                                                        <span style={{ fontSize: "12px", color: "#495057" }}>
                                                          ({savedCount})
                                                        </span>
                                                      </>
                                                    )
                                                  )}
                                                </div>
                                              </td>
                                            ) : head.key === "remark" ? (
                                              actionCheck ? (
                                                <td>
                                                  <input
                                                    type="text"
                                                    placeholder="Enter remark"
                                                    value={
                                                      formValues.find(f => f.id === row.id)?.remark ?? ""
                                                    }
                                                    onChange={(e) =>
                                                      handleRemarkChange(row.id, e.target.value)
                                                    }
                                                  />
                                                </td>
                                              ) : (
                                                <td>{row[head.key] || "-"}</td>
                                              )
                                            ) : head.key === "period_month" ? (
                                              <td>{formatMonth(row[head.key])}</td>
                                            ) : (
                                              <td>{row[head.key] || "-"}</td>
                                            )}
                                          </React.Fragment>
                                        ))}
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td colSpan="7" className="text-center text-muted fw-bold">
                                      No records available
                                    </td>
                                  </tr>
                                )}
                              </tbody>

                            </table>
                          </div>
                            {actionCheck &&
                              <div className="d-flex justify-content-end mt-3">
                                {months.length > 1 &&
                                  <div className="">
                                    <button
                                      disabled={currentMonthIndex === 0}
                                      className="btn btn-outline-primary me-2"
                                      onClick={() => setCurrentMonthIndex(prev => prev - 1)}
                                    >
                                      Previous
                                    </button>

                                    <button
                                      disabled={currentMonthIndex === months.length - 1}
                                      className="btn btn-outline-primary me-2"
                                      onClick={() => setCurrentMonthIndex(prev => prev + 1)}
                                    >
                                      Next
                                    </button>
                                  </div>
                                }
                                <div>
                                  <button type="submit" className="btn btn-primary px-4 me-4" name="save">Save</button>
                                  {currentMonthIndex === months.length - 1 && (
                                    <button type="submit" className="btn btn-success px-4" name="submit">
                                      Submit
                                    </button>
                                  )}
                                </div>
                              </div>
                            }

                          {/* </div> */}
                        </div>
                      </form>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <AttachmentViewer
          files={selectedFiles}
          setFiles={setSelectedFiles}
          fileId={fileId}
          deletedata={actionCheck}
          onClose={() => setShowModal(false)}
          showSnackbar={showSnackbar}
          setLoading={setLoading}
          fetchData= {fetchData}
        />
      )}

      <Dialog
          open={openCompleteAlert}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Are you sure you want to complete this audit? This action cannot be undone.
              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={setOpenCompleteAlertFalse}>No</Button>
              <Button onClick={handleUpdateAuditData}>Yes</Button>
          </DialogActions>
      </Dialog>
      <Dialog
          open={openCompleteAlertOne}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Are you sure you want to complete this audit.You haven’t added any remarks or uploaded any attachments? This action cannot be undone.
              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={setOpenCompleteAlertOneFalse}>No</Button>
              <Button onClick={handleUpdateAuditData}>Yes</Button>
          </DialogActions>
      </Dialog>
      <Dialog
          open={openOverrideAlert}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => handleOverrideChoice(false)}
          aria-describedby="override-file-alert"
      >
          <DialogTitle>{"File already uploaded"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="override-file-alert">
                {overrideFileName} has already been uploaded. Do you want to override it?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={() => handleOverrideChoice(false)}>No</Button>
              <Button onClick={() => handleOverrideChoice(true)}>Yes</Button>
          </DialogActions>
      </Dialog>
    </div>
  )
}

export default VendorAuditUpdate